import { api } from "./connection/api";

const PDF_ENDPOINT_PREFIX = "pdf";

interface IPdfRequest {
    html: string;
}

export const pdfApi = api.injectEndpoints({
    endpoints: builder => ({
        generatePdf: builder.mutation<Blob, IPdfRequest>({
            query: body => ({
                url: `${PDF_ENDPOINT_PREFIX}/generatePdfFromHtml`,
                method: "POST",
                body,
                responseHandler: async response => {
                    return await response.blob();
                },
            }),
        }),
    }),
});

export const {
    useGeneratePdfMutation,
} = pdfApi;
